import { render, staticRenderFns } from "./Transportation.vue?vue&type=template&id=3245d3c2&scoped=true&"
import script from "./Transportation.vue?vue&type=script&lang=js&"
export * from "./Transportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245d3c2",
  null
  
)

export default component.exports